import { UseCase } from '@/core/base/use-case';
import { NewsletterResponse } from '../models/newsletter.model';
import { NewsletterRepository } from '../repositories/newsletter.repository';
import { Observable } from 'rxjs';

export class SuscribeEmailUseCase
    implements UseCase<never, NewsletterResponse>
{
    constructor(private readonly repository: NewsletterRepository) {}
    execute(email: string): Observable<NewsletterResponse> {
        return this.repository.suscribeEmail(email);
    }
}
